<template>
  <div>
    <div class="page-title">編輯課題</div>
    <div class="page-box">
      <topicFrom
        ref="form"
        :isEdit="true"
        :formLabelAlign="formLabelAlign"
      ></topicFrom>
      <div>請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="backIndexpage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getTopicsDetail,putTopics} from '@/api/topics'
import topicFrom from "./components/topicFrom.vue";
export default {
  components: { topicFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formLabelAlign: {
        number: null,
        lang: null,
        name: null,
        scope: null,
        gradeId: null,
        grade: {
          id: null,
          name: null,
          price: null,
        },
        practises: [
          ],
        smallTest: {
          topicId: null,
          imageUrl: null,
          practises: [
            { 
              randomNumber: null,
              number:null
            },
          ],
        },
      },
    };
  },
  created(){
    this.getTopicsDetail()
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => { 
        if (valid) {
          this.putTopics()
        }
      });
      
    },
    putTopics(){
      putTopics(this.id,this.formLabelAlign).then(()=>{
         this.$message({
           type: 'success',
           message: '提交成功',
         })
         this.$router.push({ name: 'topic' })
      })
    },
    backIndexpage() {
      this.$router.push('/topic')
    },  
    getTopicsDetail(){
      getTopicsDetail(this.id).then((v)=>{
         this.formLabelAlign = v.data
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>